import { Locale } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { DEFAULT_LANGUAGE_TYPE, LangType } from './language';
import { LocalizationSetting } from './localization-setting';

export interface LocalizationStateModel {
  lang: LangType;
  /** Org unit localization (locale, currency, date/time format). Set when user/org unit is loaded. */
  localizationSetting: LocalizationSetting | null;
  /** date-fns locale matching the current lang, used by formatting pipes. */
  dateFnsLocale: Locale;
}

export const defaultLocalizationStateModel: LocalizationStateModel = {
  lang: DEFAULT_LANGUAGE_TYPE,
  localizationSetting: null,
  dateFnsLocale: enGB,
};
